import React from 'react';
import createSVG from './createSVG';

const LogoIcon = ({style}) => (
  <path style={style} d="M.316 7.27H7.27V.314H.316m0 15.263H7.27V8.623H.316M8.47 7.27h6.953V.314H8.47m0 15.263h6.953V8.623H8.47" fill="#FFF" fillRule="evenodd"/>
);

export default createSVG(LogoIcon);
